
  export const style={
    inpuStyle:{
      colorInput:"#00467D"
    },
    url:{
      urlClient:"https://lwart.prd.appnoz.com.br/",
      urlClientYouseed:"https://admyouseed.bancosemear.com.br/"
    },
    fileUrl:{
      logo:"https://timcoo-geral.s3.amazonaws.com/Logos/logo_client_lwart.png",
      secondaryLogonLogo: "null",
    },
    variables:{
       customMenuItem: true,
       autoRegister: false,
       recaptchaVersion : "V1"
    },
    CurrencyName:{
      name:"DizAí/Dizais"
    },
    teamName:{
      name:"Lwart"
    },
    hasToken: false,
    hostHeader: "lwart"
  }
